import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { AddFiscalDocumentValidationSchema } from '../schemas/addFiscalDocument.schema';

interface UseCreateBillFiscalDocumentProps {
  billId: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useCreateBillFiscalDocument = ({ billId, onSuccess, onError }: UseCreateBillFiscalDocumentProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createBillFiscalDocument', billId],
    mutationFn: async ({ form, pdf, xml }: { form: AddFiscalDocumentValidationSchema; pdf?: File; xml?: File; }) => {
      const fiscal_document = {
        ...form,
        pdf,
        xml,
      };

      return privateAxios.postForm(`/billing/bills/${billId}/fiscal_documents`, {
        fiscal_document,
      });
    },
    onSuccess,
    onError,
  });
};
